import { ERROR, GET_ALL_OFFICERS, GET_ALL_TASK_CATEGORIES, GET_ALL_TASK_PRIORITIES, GET_ALL_TASK_STATUSES, GET_ALL_TASK_TYPES, GET_ALL_TASKS, GET_DASHBOARD_SUMMARY, GET_RECENT_UPDATES, GET_SINGLE_TASK, LOADER } from "../actionType";

let initialState = {
    loading: false,
    error: null,
    taskStatuses: [],
    taskCategories: [],
    taskTypes: [],
    taskPriorities: [],
    tasks: {},
    officers: [],
    dashboardSummary: {},
    allRecentUpdates: {},
    singleTask: null,
    currentTaskId: null,
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case LOADER:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_ALL_TASKS:
            return {
                ...state,
                tasks: { data: payload.tasks, pagination: payload.pagination  }
            }
        case GET_SINGLE_TASK:
            return {
                ...state,
                singleTask: { data: payload }
            }
        case GET_ALL_TASK_STATUSES:
            return {
                ...state,
                taskStatuses: payload
            }
        case GET_ALL_TASK_PRIORITIES:
            return {
                ...state,
                taskPriorities: payload
            }
        case GET_ALL_TASK_CATEGORIES:
            return {
                ...state,
                taskCategories: payload
            }
        case GET_ALL_TASK_TYPES:
            return {
                ...state,
                taskTypes: payload
            }
        case GET_ALL_OFFICERS:
            return {
                ...state,
                officers: payload
            }
        case GET_DASHBOARD_SUMMARY:
            return {
                ...state,
                dashboardSummary: payload
            }
        case GET_RECENT_UPDATES:
            return {
                ...state,
                allRecentUpdates: { data: payload.task_update, pagination: payload.pagination  }
            }
        default:
            return state;
    }
};
